import { MOKA_INVENTORY_API } from '../../constants';

export const V1_URL = `${MOKA_INVENTORY_API}/v1/inventory`;
export const V1_TRANSFERS = `${V1_URL}/ingredient-transfers`;
export const V1_EXPORT = `${V1_TRANSFERS}/export`;
